// Stops a focused <input type="number"> from changing its value when the user
// scrolls over it (mouse wheel / trackpad) — the browser default silently
// corrupted quote quantities and discounts (CONEK-5346, DH-12681).
//
// Blurring before the browser handles the gesture means the value stays put and
// the page (or nearest scroll container) scrolls natively. Typing, the stepper
// arrows and the ↑/↓ keys still change the value. Add `data-allow-wheel-step`
// to an input to keep the native scroll-to-step behaviour on purpose.

const installed = new WeakSet<Document>()

function handleWheel(event: WheelEvent): void {
  const target = event.target
  if (!(target instanceof HTMLInputElement)) return
  if (target.type !== "number") return
  if (target.ownerDocument.activeElement !== target) return
  if (target.hasAttribute("data-allow-wheel-step")) return

  target.blur()
}

export function installNumberInputWheelGuard(doc: Document): void {
  if (installed.has(doc)) return
  installed.add(doc)

  doc.addEventListener("wheel", handleWheel, { capture: true, passive: true })
}
